module.exports = __webpack_public_path__ + "static/media/entity-viewer-left-pane.df0e5dc5.png";